import Main from './Main.jsx';

export default function Home(){

  return(
    <div>
      <Main />
    </div>);
}
